import { Discord } from 'flowbite-react-icons/solid'
import Image from 'next/image'
import Slack from '@/public/images/icons/slack.svg'
import { FaTelegram } from 'react-icons/fa'

const SocialNetwork = ({ socialNetwork }: { socialNetwork: string }) => {
  return (
    <div className="w-fit px-2.5 py-0.5 bg-white rounded-full border">
      {socialNetwork === 'discord' && <Discord className="h-4" />}
      {socialNetwork === 'slack' && <Image src={Slack} alt="Slack" />}
      {socialNetwork === 'telegram' && <FaTelegram className="h-4" />}
    </div>
  )
}

export default SocialNetwork
